var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "600",
        "overlay-color": "black",
        "overlay-opacity": "0.8"
      },
      model: {
        value: _vm.open,
        callback: function($$v) {
          _vm.open = $$v
        },
        expression: "open"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(" " + _vm._s(_vm.title) + " ")
          ]),
          _c(
            "v-card-text",
            { staticClass: "px-6" },
            [
              _c(
                "v-form",
                {
                  attrs: { id: "admin-banner-form", autocomplete: "off" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submitAction($event)
                    }
                  }
                },
                [
                  _c("text-box", {
                    attrs: { label: "Názov", max: 50, cache: false },
                    model: {
                      value: _vm.nazov,
                      callback: function($$v) {
                        _vm.nazov = $$v
                      },
                      expression: "nazov"
                    }
                  }),
                  _c("text-box", {
                    attrs: { label: "Titulok", max: 50, cache: false },
                    model: {
                      value: _vm.titulok,
                      callback: function($$v) {
                        _vm.titulok = $$v
                      },
                      expression: "titulok"
                    }
                  }),
                  _c("text-box", {
                    attrs: { label: "Info", max: 50, cache: false },
                    model: {
                      value: _vm.info,
                      callback: function($$v) {
                        _vm.info = $$v
                      },
                      expression: "info"
                    }
                  }),
                  _c("text-box", {
                    attrs: { label: "Text vľavo", cache: false, max: 50 },
                    model: {
                      value: _vm.textVlavo,
                      callback: function($$v) {
                        _vm.textVlavo = $$v
                      },
                      expression: "textVlavo"
                    }
                  }),
                  _c("text-box", {
                    attrs: { label: "Text vpravo", cache: false, max: 50 },
                    model: {
                      value: _vm.textVpravo,
                      callback: function($$v) {
                        _vm.textVpravo = $$v
                      },
                      expression: "textVpravo"
                    }
                  }),
                  _c("text-box", {
                    attrs: {
                      label: "Presmerovanie URL",
                      cache: false,
                      url: true,
                      max: 100
                    },
                    model: {
                      value: _vm.presmerovanieUrl,
                      callback: function($$v) {
                        _vm.presmerovanieUrl = $$v
                      },
                      expression: "presmerovanieUrl"
                    }
                  }),
                  _c("date-picker", {
                    attrs: {
                      placeholder: "DD/MM/YYYY",
                      label: "Dátum do",
                      cache: false
                    },
                    model: {
                      value: _vm.datumDo,
                      callback: function($$v) {
                        _vm.datumDo = $$v
                      },
                      expression: "datumDo"
                    }
                  }),
                  _c("dynamic-combo", {
                    ref: "znacka",
                    attrs: {
                      cache: false,
                      multiple: true,
                      "data-id": "liw_filip__admin_banner__cb_znacky",
                      dynamic: "",
                      clearable: "",
                      lite: "",
                      autoload: ""
                    },
                    model: {
                      value: _vm.znacka,
                      callback: function($$v) {
                        _vm.znacka = $$v
                      },
                      expression: "znacka"
                    }
                  }),
                  _c("dynamic-combo", {
                    ref: "rola",
                    attrs: {
                      cache: false,
                      multiple: true,
                      "data-id": "liw_filip__admin_banner__cb_role",
                      dynamic: "",
                      clearable: "",
                      lite: "",
                      autoload: ""
                    },
                    model: {
                      value: _vm.rola,
                      callback: function($$v) {
                        _vm.rola = $$v
                      },
                      expression: "rola"
                    }
                  }),
                  _c("dynamic-combo", {
                    ref: "umiestnenia",
                    attrs: {
                      cache: false,
                      multiple: true,
                      "data-id": "liw_filip__admin_banner__cb_umiestnenie",
                      dynamic: "",
                      clearable: "",
                      lite: "",
                      autoload: ""
                    },
                    model: {
                      value: _vm.id_umiestnenia_multi,
                      callback: function($$v) {
                        _vm.id_umiestnenia_multi = $$v
                      },
                      expression: "id_umiestnenia_multi"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "pt-4",
                      on: {
                        drop: function($event) {
                          $event.preventDefault()
                          return _vm.addDroppedFile($event)
                        },
                        dragover: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("v-file-input", {
                        ref: "darkImage",
                        attrs: {
                          label:
                            "Obrázok pozadia tmavá téma (rozlíšenie 1110x236)",
                          "prepend-icon": "mdi-image-area",
                          accept: "image/png, image/jpeg, image/jpg"
                        },
                        on: { change: _vm.onFileSelectDark }
                      }),
                      _c("v-file-input", {
                        ref: "darkMobileImage",
                        staticClass: "pb-6",
                        attrs: {
                          label:
                            "Obrázok pozadia pre mobil tmavá téma (rozlíšenie 343x310 / .svg)",
                          "prepend-icon": "mdi-image-area",
                          accept:
                            "image/png, image/jpeg, image/jpg, image/svg+xml"
                        },
                        on: { change: _vm.onMobileFileSelectDark }
                      }),
                      _c("v-file-input", {
                        ref: "lightImage",
                        attrs: {
                          label:
                            "Obrázok pozadia svetlá téma (rozlíšenie 1110x236)",
                          "prepend-icon": "mdi-image-area",
                          accept: "image/png, image/jpeg, image/jpg"
                        },
                        on: { change: _vm.onFileSelectLight }
                      }),
                      _c("v-file-input", {
                        ref: "lightMobileImage",
                        staticClass: "pb-6",
                        attrs: {
                          label:
                            "Obrázok pozadia pre mobil svetlá téma (rozlíšenie 343x310 / .svg)",
                          "prepend-icon": "mdi-image-area",
                          accept:
                            "image/png, image/jpeg, image/jpg, image/svg+xml"
                        },
                        on: { change: _vm.onMobileFileSelectLight }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "btn-primary",
                  attrs: { type: "submit", form: "admin-banner-form" }
                },
                [_vm._v(" Uložiť ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }